import r from"./Success.js";import o from"./Error.js";var s={Success:r,Error:o};export{s as default};
//# sourceMappingURL=index.js.map
